<div class="error-page-container">
  <mat-card>
    <mat-card-content>
      <img src="assets/images/error-images/error.png" />

      <div class="content-container">
        <div>
          <h1 class="title">{{ 'error.title' | translate }}</h1>
          <h2 class="sub-title">{{ 'error.sub_title' | translate }}</h2>
        </div>

        <button mat-flat-button color="accent" routerLink="/">
          {{ 'common.go_to_home_page' | translate }}
        </button>
      </div>
    </mat-card-content>
  </mat-card>
</div>
